/** Strings owned by `src/features/challenges/` — WP-05's Challenges page
 * (counts, cards with status actions, the new-challenge form). */
export const challenges = {
  page: {
    title: 'Challenges',
    lead: 'Run team challenges: steps, sleep, workouts and more, with an optional leaderboard.',
    noCompany: 'Select a company to see its challenges.',
    forbidden: 'You do not have access to this company’s challenges.',
    empty: 'No challenges yet — create the first one.',
  },
  counts: {
    active: 'Active challenges',
    draft: 'Drafts',
    completed: 'Completed',
    totalParticipants: 'Total participants',
  },
  sections: {
    activePublished: 'Active & published',
    draftsCompleted: 'Drafts & completed',
  },
  card: {
    type: 'Type',
    mode: 'Mode',
    period: 'Period',
    goal: 'Goal',
    reward: 'Reward',
    participants: 'Participants',
    engagement: 'Engagement',
    completion: 'Completion',
    leaderboardVisible: 'Leaderboard visible',
    leaderboardHidden: 'Leaderboard hidden',
  },
  mode: {
    individual: 'Individual',
    group: 'Team',
  },
  status: {
    draft: 'Draft',
    active: 'Active',
    paused: 'Paused',
    completed: 'Completed',
  },
  type: {
    steps: 'Steps',
    sleep: 'Sleep',
    workouts: 'Workouts',
    meditation: 'Meditation',
    custom: 'Custom',
  },
  actions: {
    newChallenge: 'New challenge',
    publish: 'Publish',
    pause: 'Pause',
    resume: 'Resume',
    finish: 'Finish',
    duplicate: 'Duplicate as draft',
    duplicateSuffix: 'copy',
    viewLeaderboard: 'View leaderboard',
    hideLeaderboard: 'Hide leaderboard',
  },
  leaderboard: {
    title: 'Leaderboard',
    empty: 'No participants yet.',
  },
  form: {
    title: 'New challenge',
    submit: 'Create challenge',
    cancel: 'Cancel',
    fields: {
      title: 'Title',
      description: 'Description',
      type: 'Type',
      mode: 'Mode',
      startDate: 'Start date',
      endDate: 'End date',
      goalValue: 'Goal value',
      unit: 'Unit',
      reward: 'Reward',
      leaderboardVisible: 'Show leaderboard to participants',
    },
    errors: {
      required: 'This field is required.',
      endBeforeStart: 'End date cannot be before the start date.',
    },
  },
} as const;
